// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"474":"RegisterYourBeys","534":"randomizer","552":"rules","644":"account","730":"tournament-ban"}[chunkId] + "." + {"474":"4ee8f31c","534":"b662ff3f","552":"8b640709","644":"1f2d1c40","730":"6c9f041b"}[chunkId] + ".css";
};